/* eslint-disable object-shorthand */
/* eslint-disable camelcase */
/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import {
  Badge,
  Box,
  Button,
  FormControl,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  NativeSelect,
  Select,
  Switch,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useQueryParams } from '../../../../util/utils'
import { usePermissions } from '../../../../hooks/usePermission'
import { fetchAttendanceInit } from '../../../attendance/AttendanceActions'
import { Link, Route } from 'react-router-dom'
import {
  mdiAccountSearch,
  mdiFilterMultiple,
  mdiMagnifyExpand,
  mdiMicrosoftExcel,
  mdiNoteEditOutline,
} from '@mdi/js'
import Icon from '@mdi/react'
import BaseFilter from '../../../../components/hooks/BaseFilter'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import SelectField from '../../../components/SelectField'
import { fetchServiceItems, makeReport } from '../ItemsReportActions'
import colors from '../../../../assets/colors'
import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'
import { KeyboardDatePicker } from '@material-ui/pickers'
import SearchIcon from '@material-ui/icons/Search'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import { isValid } from 'date-fns'

const useStyles = makeStyles({
  container: {
    width: '370px',
  },
  form: {
    maxHeight: 'calc(330px + 50px)',
    overflowY: 'auto',
  },
})

export default function Filter(props) {
  const laundries = useSelector(state => state.laundryItemsReport.laundries)
  const statuses = useSelector(state => state.laundryItemsReport.statuses)

  const meta = useSelector(state => state.laundryItemsReport.meta)
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canRead } = usePermissions()

  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const filters = useQueryParams(location.search)

  const [form, setForm] = useState({
    laundry_id: '',
    date_start: null,
    date_end: null,
    laundry: '',
  })

  const filterClasses = filterStylesComponents()

  const laundryFiltered = useMemo(() => {
    if (!laundries?.length) return ''
    if (!filters?.laundry_id) return ''
    return laundries?.find(r => r?.id == filters?.laundry_id)
  }, [laundries, filters])

  const statusFiltered = useMemo(() => {
    if (!laundries?.length) return ''
    if (!filters?.status_id) return ''
    return statuses?.find(r => r?.id == filters?.status_id)
  }, [statuses, filters])

  const [open, setOpen] = useState(false)

  const toggleModal = () => {
    setOpen(!open)
  }

  const handleChange = e => {
    e.preventDefault()

    const { name, value } = e.target

    setForm({
      ...form,
      [name]: value,
    })
  }

  const handleChangeLaundry = (name, value, dispatch = false) => {
    const data = {
      ...form,
      [name]: value,
    }

    setForm(data)

    if (!dispatch) return

    const values = {
      ...filters,
      laundry_id: value?.id || '',
    }
    onSubmit(values)
  }

  const onSubmit = (data = form) => {
    const searchParams = new URLSearchParams(data)
    searchParams.set('page', 1)
    if (open) toggleModal()
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const handleSubmit = e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)

    data.append('status_id', form.status?.id || '')
    data.append('laundry_id', form?.laundry?.id || '')

    data.append(
      'date_start',
      form.date_start && isValid(form.date_start)
        ? new Date(form.date_start).toISOString()
        : ''
    )

    data.append(
      'date_end',
      form.date_end && isValid(form.date_end)
        ? new Date(form.date_end).toISOString()
        : ''
    )

    const entries = data.entries()
    const values = Object.fromEntries(entries)

    onSubmit({ ...filters, ...values })
  }

  useEffect(() => {
    if (!laundryFiltered) return
    setForm({ ...form, laundry: laundryFiltered })
  }, [laundryFiltered])

  useEffect(() => {
    if (!statusFiltered) return
    setForm({ ...form, status: statusFiltered })
  }, [statusFiltered])

  return (
    <>
      <BaseFilter>
        <Grid item xs={12}>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
          >
            <Grid item xs={10} sm={12} md={6}>
              <form style={{ width: '100%' }} onSubmit={handleSubmit}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <Input
                      fullWidth
                      name="bar_code"
                      style={{ marginTop: '16px' }}
                      defaultValue={filters?.bar_code}
                      id="standard-adornment-person"
                      placeholder="Pesquise por Etiqueta"
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="search bar_code"
                            type="submit"
                          >
                            <Icon path={mdiMagnifyExpand} size={1} />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <SelectField
                      options={laundries}
                      setForm={(name, value) => {
                        handleChangeLaundry(name, value, true)
                      }}
                      data={form?.laundry || ''}
                      name="laundry"
                      label="Filtre por Lavanderia"
                    />
                  </Grid>
                </Grid>
              </form>
            </Grid>

            <Grid item xs={12} sm={12} md>
              <Grid
                container
                alignItems="center"
                justifyContent="flex-end"
                spacing={2}
              >
                <Grid item xs={12} className={filterClasses.areaButtons}>
                  <IconButton
                    className={filterClasses.btnMoreFilters}
                    onClick={toggleModal}
                    color={colors.textPrimary}
                  >
                    <Icon
                      path={mdiFilterMultiple}
                      size={1}
                      color={colors.secondary}
                    />
                    Outros Filtros
                  </IconButton>

                  {canRead('modulo-parceiros-relatorio-itens', permissionUser) && (
                    <IconButton
                      className={filterClasses.btnAdd}
                      onClick={() => {
                        dispatch(makeReport({ ...filters, download: true }))
                      }}
                    >
                      <Icon path={mdiMicrosoftExcel} size={1} />
                      Download
                    </IconButton>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <BaseFilterModal open={open} handleOpen={toggleModal} title="FILTRO">
          <Grid item xs={12} style={{ width: '450px' }}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography
                  style={{ fontSize: '16px', fontWeight: 'normal' }}
                  color={colors.primary}
                >
                  Utilize os campos abaixo para encontrar <br /> um item de
                  atendimento
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={4}>
                    <Grid item xs={12} sm={6}>
                      <Input
                        fullWidth
                        style={{ marginTop: '16px' }}
                        name="bar_code"
                        defaultValue={filters?.bar_code}
                        id="standard-adornment-person"
                        placeholder="Pesquise por Etiqueta"
                      />
                    </Grid>

                    <Grid item sm={6} xs={12}>
                      <SelectField
                        options={laundries}
                        setForm={(name, value) => {
                          handleChangeLaundry(name, value)
                        }}
                        data={form?.laundry || ''}
                        name="laundry"
                        label="Filtre por Lavanderia"
                      />
                    </Grid>

                    <Grid item sm={6} xs={12} lg={6}>
                      <KeyboardDatePicker
                        clearable
                        value={form.date_start || filters?.date_start || null}
                        label="Data da coleta (de)"
                        fullWidth
                        clearLabel="Limpar"
                        invalidDateMessage="Data inválida"
                        autoOk
                        inputVariant="standard"
                        onChange={date =>
                          setForm({
                            ...form,
                            date_start: date,
                          })
                        }
                        format="dd/MM/yyyy"
                      />
                    </Grid>

                    <Grid item sm={6} xs={12} lg={6}>
                      <KeyboardDatePicker
                        clearable
                        value={form.date_end || filters?.date_end || null}
                        label="Data da coleta (até)"
                        fullWidth
                        clearLabel="Limpar"
                        invalidDateMessage="Data inválida"
                        autoOk
                        inputVariant="standard"
                        onChange={date =>
                          setForm({
                            ...form,
                            date_end: date,
                          })
                        }
                        format="dd/MM/yyyy"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <SelectField
                        fullWidth
                        options={statuses}
                        setForm={(e, value) => {
                          setForm({
                            ...form,
                            status: value,
                            status_id: value?.id,
                          })
                        }}
                        data={form.status || null}
                        name="status"
                        label="Status"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        select
                        name="is_rework"
                        defaultValue={filters?.is_rework}
                        fullWidth
                        label="Retrabalho"
                      >
                        <MenuItem value="">Selecione</MenuItem>
                        <MenuItem value="0">Não</MenuItem>
                        <MenuItem value="1">Sim</MenuItem>
                      </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        select
                        name="is_delivery"
                        defaultValue={filters?.is_delivery}
                        fullWidth
                        label="Delivery"
                      >
                        <MenuItem value="">Selecione</MenuItem>
                        <MenuItem value="0">Não</MenuItem>
                        <MenuItem value="1">Sim</MenuItem>
                      </TextField>
                    </Grid>

                    <Grid item xs={12}>
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="center"
                        style={{ margin: '1em' }}
                      >
                        <Grid item>
                          <Button
                            type="submit"
                            color={colors.primary}
                            variant="contained"
                            className={filterClasses.btnAdd}
                          >
                            <SearchIcon />
                            {` Pesquisar`}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </Grid>
        </BaseFilterModal>
      </BaseFilter>
    </>
  )
}
